import {dateFixer} from "./dateFixer";

export const dateToString = (date: Date) => {
    return dateFixer(date).toISOString().slice(0, 10);
};
